import Close from '~/components/MaterialIcons/Close';
import Email from '~/components/MaterialIcons/Email';
import Menu from '~/components/MaterialIcons/Menu';
import PlayArrow from '~/components/MaterialIcons/PlayArrow';
import Share from '~/components/MaterialIcons/Share';

export { Close, Email, Menu, PlayArrow, Share };
